import { GridRow } from '@mytours/components'
import { getDirMode } from 'mobile_web/modules/platform'
import React from 'react'

interface Props {
	title: string
	noOverflow?: boolean
}

const SectionHeader: React.FC<Props> = ({ title, noOverflow }): React.ReactElement => (
	<GridRow className="block-header" dir={getDirMode()}>
		<h2 className={`subheading ${noOverflow ? 'subheading-no-overflow' : ''}`} data-cy="story-screen-section-heading">
			{title}
		</h2>
	</GridRow>
)

export default SectionHeader
